import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import fishscopeLogo from '@/assets/FISHSCOPE_logo.png';
import './index.css';
import App from './App.tsx';

// Preload logo image to prevent flickering on page transitions
const preloadLogo = () => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = fishscopeLogo;
  document.head.appendChild(link);
};

// Preload logo immediately
preloadLogo();

// Initialize Sentry if DSN is provided and not in local development
if (import.meta.env.VITE_SENTRY_DSN && !import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    ],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: import.meta.env.VITE_ENABLE_LOGGING === 'true',
  });
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
